import { createRouter, createWebHistory } from 'vue-router'

/**
 * 路由工厂
 * @param {import("@portal/vue-helper").RouteTree} routes 路由树数
 * @param {string} basename 基础路径
 * @returns
 */
const buildRouter = (routes, basename) => {
  return createRouter({
    history: createWebHistory(basename),
    routes
  })
}

export default buildRouter
